import { useRef } from 'react';
import { moveEventsScrollbar } from 'Components/Atoms/A_EQViewer/moveEventsScrollbar';

export const useMarkerState = ( selectEvent, positionMap ) => {

    const positionRef = useRef( positionMap );

    const handleSelectedMarker = ( event, findIndex, handleDevice ) => {
        if ( event ) {
            moveEventsScrollbar( findIndex( event ) );
            const { place, validate } = handleDevice( event );
            if ( validate ) { positionRef.current = place }
        }
        selectEvent( event ); // this update the state
    }

    return { positionRef, handleSelectedMarker };

};